import { render, staticRenderFns } from "./upServer.vue?vue&type=template&id=44b449b4&scoped=true&"
import script from "./upServer.vue?vue&type=script&lang=js&"
export * from "./upServer.vue?vue&type=script&lang=js&"
import style0 from "./upServer.vue?vue&type=style&index=0&id=44b449b4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b449b4",
  null
  
)

export default component.exports